//#region src/tree/id.ts
/**
* Joins a parent scope with a local segment.
*
* If `nodeId` starts with `#/`, it is treated as absolute and returned as-is.
*
* @see {@link NodeId}
*/
function joinId(scope, nodeId) {
	if (nodeId.startsWith("#/")) return nodeId;
	return scope + "/" + nodeId;
}
/**
* Determines whether `childId` is a descendant of `parentId` based on ID path
*
* @return `true` when `childId` is a descendant path of `parentId`.
*/
function isParent(parentId, childId) {
	return childId.startsWith(parentId + "/");
}
/**
* Given a parent and a descendant IDs determines ID of a direct child
*
* @return ID of a direct child of `parentId` or `null` if `descendantId` is not a descendant of `parentId`.
*
* @example
* ```ts
* childLocalId("#/container", "#/container/item/nested"); // "#/container/item"
* childLocalId("#/container", "#/container/item"); // "#/container/item"
* childLocalId("#/container", "#/another/item/nested"); // null
* ```
*
* @see {@link NodeId}
*/
function childLocalId(parentId, descendantId) {
	if (!isParent(parentId, descendantId)) return null;
	const slash = descendantId.indexOf("/", parentId.length + 1);
	if (slash === -1) return descendantId;
	return descendantId.substring(0, slash);
}
/**
* Traverses the path from `nodeId` to the root and calls a callback for each node
*/
function idsToRoot(nodeId, cb) {
	if (cb(nodeId) === false) return;
	for (;;) {
		const idx = nodeId.lastIndexOf("/");
		if (idx === -1) return;
		nodeId = nodeId.substring(0, idx);
		if (cb(nodeId) === false) return;
	}
}
/**
* Traverses node ID segments starting from two IDs until they converge.
* From that point on the callback is called only once for each segment in the common path
* Used when notifying focus listeners
*/
function convergingPaths(node1, node2, cb) {
	if (node1 !== node2) idsToRoot(node2, (id) => {
		if (isParent(id, node1)) return false;
		cb(id);
	});
	idsToRoot(node1, cb);
}
//#endregion
export { childLocalId, convergingPaths, idsToRoot, isParent, joinId };

//# sourceMappingURL=id.js.map